<template>
<div class="page" style="background-color: #ffffff;height: 100%;">
    <van-nav-bar title="门店业绩" left-text="返回" left-arrow @click-left="historyBack"/>
    <div style="width: 100%;" class="mypage">
        <!--<el-button size="mini" @click="openStore">{{storename}}</el-button>-->
        <el-form :inline="true" class="demo-form-inline" size="mini">
            <el-form-item label="门店">
                <el-select v-model="storeid" placeholder="门店选择" @change="storeChange" style="width: 120px;">
                  <el-option :label="item.brandname" :value="item.brandid" v-for="(item,key) in store_data" :key="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-radio-group v-model="tabPosition" @change="perfClick" size="mini">
                    <el-radio-button label="2">本月</el-radio-button>
                    <el-radio-button label="3">上月</el-radio-button>
                </el-radio-group>
                <el-button v-popover:popover1 size="mini">自定义(月)</el-button>
                <el-button v-popover:popover2 size="mini">自定义(天)</el-button>
            </el-form-item>
        </el-form>
        <el-popover placement="bottom" width="400" ref="popover1" trigger="click">
            <el-form label-position="left" inline class="myform" style="margin-left: 50px">
                <el-row>
                <el-col :span="24">
                    <el-form-item label="日期">
                    <el-date-picker style="width: 130px" size="mini" v-model="bfrommonth" type="month" :editable="false" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                    </el-date-picker>
                    <el-date-picker style="width: 130px" size="mini" v-model="btomonth" type="month" :editable="false" placeholder="选择月" value-format="yyyy-MM" @change="monthchange">
                    </el-date-picker>
                    </el-form-item>
                </el-col>
                </el-row>
            </el-form>
        </el-popover>
        <el-popover placement="bottom" width="400" ref="popover2" trigger="click">
          <el-form label-position="left" inline class="myform" style="margin-left: 50px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="日期">
                  <el-date-picker style="width: 130px" size="mini" v-model="dayfromdate" type="date" :editable="false" placeholder="选择天" value-format="yyyy-MM-dd" @change="dayChange">
                  </el-date-picker>
                  <el-date-picker style="width: 130px" size="mini" v-model="daytodate" type="date" :editable="false" placeholder="选择天" value-format="yyyy-MM-dd" @change="dayChange">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-popover>
    </div>


    <el-table :data="custInfos" border style="width: 100%"  size="mini" height="calc(100% - 6.5rem)" v-loading="querybutton">
        <el-table-column prop="lable" align="center" label="名称"></el-table-column>
        <el-table-column prop="curamount" align="center" label="今天"></el-table-column>
        <el-table-column prop="nowmonth" align="center" :label="columnname1" >
          <template slot-scope="scope">
            {{ parseInt(scope.row.nowmonth)/10}}
            <span v-if="scope.row.nownumber>0">({{scope.row.nownumber/10}})</span>
          </template>
        </el-table-column>
        <el-table-column prop="befogermonth" align="center"  :label="columnname2" >
          <template slot-scope="scope">
            {{ parseInt(scope.row.befogermonth/10)}}
            <span v-if="scope.row.befogernumber>0">({{scope.row.befogernumber/10}})</span>
          </template>
        </el-table-column>
        <el-table-column prop="lv" label="增长率" width="65" align="center">
          <template slot-scope="scope">
            {{Math.round(scope.row.lv * 100)}}%
          </template>
        </el-table-column>
      </el-table>
</div>
</template>
<script>
    export default {
        data(){
            return {
                querybutton:false,
                storeid:localStorage.getItem("storeid"),
                store_data:[],
                defaultProps: {
                    children: 'items',
                    label: 'name'
                },
                store_data_show:false,
                custInfos:[],
                storename:localStorage.getItem("storename"),
                tabPosition:"2",
                storeShow:false,
                fromdate:this.$moment().startOf('month').format('YYYY-MM-DD'),
                todate:this.$moment().endOf('month').format('YYYY-MM-DD'),
                bfromdate:this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
                btodate:this.$moment().subtract(1, 'days').format('YYYY-MM-DD'),
                columnname1:"本月",
                columnname2:"上月",
                bfrommonth:"",
                btomonth:"",
                dayfromdate:"",
                daytodate:"",
            }
        },
        created: function () {

            let now=this.$moment().format('YYYY-MM-DD');
            let endmonth=this.$moment().endOf('month').format('YYYY-MM-DD');

            this.todate=this.$moment(now).subtract(1,'days').format("YYYY-MM-DD");
            this.fromdate=this.$moment(this.todate).startOf('month').format('YYYY-MM-DD')

            //this.todate="2021-09-30";
            this.bfromdate=this.$moment(this.fromdate).subtract(1,'month').format("YYYY-MM-DD");
            this.btodate=this.$moment(this.todate).subtract(1,'month').format("YYYY-MM-DD");
            if(endmonth==this.todate){
                this.btodate=this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD')
            }
            this.get_store_position_info();
            this.getHairDataByStaffId();
        },
        methods:{
            storeChange(val){
                localStorage.setItem("storeid",val);
                this.storeid=val;
                this.getHairDataByStaffId();
            },
            getHairDataByStaffId(){
                this.querybutton=true;
                this.$post("staff/getStorePerfByDate",{storeid:this.storeid,fromdate:this.fromdate,todate:this.todate,bfromdate:this.bfromdate,btodate:this.btodate}).then(res=>{
                    this.querybutton=false;
                    if(res.sucess){
                        this.custInfos=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            get_store_position_info(){
                let storeid=localStorage.getItem("parentstoreid");
                let staffid=localStorage.getItem("staffid");
                this.$post("store/getStoreByStructsByStaffId",{storeid:storeid,staffid:staffid}).then(res=>{
                    if(res.sucess){
                        this.store_data=res.object;
                    }
                    else{
                        this.$message({message: res.message,type: 'error'});
                    }
                });
            },
            handleNodeClick(data){
                this.store_data_show = false;
                this.storename = data.name;
                this.storeid = data.id;
                this.getHairDataByStaffId();
            },
            dayChange(e){
              if (this.dayfromdate && this.daytodate) {
                this.fromdate=this.dayfromdate;
                this.todate=this.daytodate;
                this.bfromdate=this.dayfromdate;
                this.btodate=this.daytodate;
                this.$refs["popover2"].doClose();
                this.getHairDataByStaffId();
              }
            },
            monthchange(e) {
                if (this.bfrommonth && this.btomonth) {
                    this.fromdate = this.bfrommonth + "-01";
                    this.todate = this.$moment(this.fromdate).endOf('month').format('YYYY-MM-DD');
                    this.bfromdate = this.btomonth + "-01";
                    this.btodate = this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD');
                    this.columnname1=this.fromdate.substring(5,7)+"月";
                    this.columnname2=this.bfromdate.substring(5,7)+"月";
                    this.bfrommonth="";
                    this.btomonth="";
                    this.$refs["popover1"].doClose();
                    this.getHairDataByStaffId();
                }
            },
            openStore(){
                this.storeShow=true;
            },
            perfClick(e){

                if(e=="1"){
                    this.fromdate=this.$moment().format("YYYY-MM-DD");
                    this.todate=this.$moment().format("YYYY-MM-DD");
                    this.bfromdate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.btodate=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.columnname1="今天";
                    this.columnname2="昨天";
                }
                else if(e=="2"){
                    let now=this.$moment().format('YYYY-MM-DD');
                    let endmonth=this.$moment().endOf('month').format('YYYY-MM-DD');

                    this.todate=this.$moment(now).subtract(1,'days').format("YYYY-MM-DD");
                    this.fromdate=this.$moment(this.todate).startOf('month').format('YYYY-MM-DD')

                    //this.todate="2021-09-30";
                    this.bfromdate=this.$moment(this.fromdate).subtract(1,'month').format("YYYY-MM-DD");
                    this.btodate=this.$moment(this.todate).subtract(1,'month').format("YYYY-MM-DD");
                    if(endmonth==this.todate){
                        this.btodate=this.$moment(this.bfromdate).endOf('month').format('YYYY-MM-DD')
                    }
                    this.columnname1="本月";
                    this.columnname2="上月";
                }
                else if(e=="3"){
                    let days=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.fromdate=days+"-01";
                    this.todate=days+"-"+this.$moment(this.fromdate, "YYYY-MM-DD").daysInMonth();
                    this.columnname1=days.substring(5,7)+"月";

                    days=this.$moment(this.fromdate).startOf('month').subtract(1, 'days').format('YYYY-MM');
                    this.bfromdate=days+"-01";
                    this.btodate=days+"-"+this.$moment(this.bfromdate, "YYYY-MM-DD").daysInMonth();
                    this.columnname2=days.substring(5,7)+"月";
                }
                else{
                    return;
                }
                this.getHairDataByStaffId();
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/manager/newmanager.vue